var map = {
	"./banner_desktop.png": 85186,
	"./banner_mobile.png": 47347,
	"./bg-roadmap.png": 97948,
	"./bg-rule.png": 96860,
	"./box-1.png": 13183,
	"./box-2.png": 56624,
	"./box-3.png": 19583,
	"./box-4.png": 75977,
	"./box-5.png": 31080,
	"./check_rank_btn.png": 16938,
	"./claim_btn.png": 24100,
	"./claimed_btn.png": 98967,
	"./done_icon.png": 67216,
	"./guideline_btn.png": 88234,
	"./mag.png": 81191,
	"./mongen-decor-1.png": 34989,
	"./mongen-decor-2.png": 75630,
	"./mstr.png": 10993,
	"./not_done_icon.png": 64058,
	"./refer_btn.png": 56584,
	"./refer_now.png": 86938,
	"./referral-arrow.png": 30087,
	"./reward-bg.png": 14772,
	"./star-icon.png": 79943,
	"./table-indicator.png": 26459,
	"./text-bg-1.png": 87588,
	"./text-bg-1old.png": 22281,
	"./text-bg-referrel.png": 54747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97956;